
  export default {

    loadAEPTracking() {
      // Load  Library
      if (window.apcConfig && window.apcConfig.aep) {
        const aepTracking = document.createElement('script');
        aepTracking.src = window.apcConfig?.aep.jsLib;
        aepTracking.async = true;
        document.head.appendChild(aepTracking);
      }
  
    },
  
    init() {
      //  Load aep tracking Script
      this.loadAEPTracking();
    },
  };